import React, { useEffect, useState } from 'react'
import { Grid, Button, Box, Checkbox, Typography, Divider } from "@mui/material"
import { styled } from '@mui/material/styles'
import * as actions from "../../../containers/Releases/CreateReleases/actions"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { API_URL } from '../../../constants';
import { toastError, toastSuccess } from '../../../utils';
import { useHistory } from "react-router-dom"

const StyledButton = styled(Button)(({ theme }) => ({
    fontFamily: "'DM Sans', sans-serif",
    background: 'linear-gradient(135deg, #00bfa5 0%, #00897b 100%)',
    fontSize: '1.1rem',
    fontWeight: 700,
    height: 56,
    minWidth: 180,
    borderRadius: '12px',
    color: "white",
    textTransform: 'none',
    boxShadow: '0 6px 16px rgba(0, 191, 165, 0.4)',
    transition: 'all 0.3s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #00897b 0%, #00695c 100%)',
        boxShadow: '0 8px 24px rgba(0, 191, 165, 0.5)',
        transform: 'translateY(-2px)',
    },
    '&:disabled': {
        background: '#e0e0e0',
        color: '#9e9e9e',
        boxShadow: 'none',
    }
}));

const SubmissionCard = styled(Box)({
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    padding: '32px',
    marginBottom: '24px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
});

function Submission(props) {

    const history = useHistory();

    const { releaseID } = props;
    const [finalInfo, setFinalInfo] = useState({})
    const [checkTerm, setCheckTerm] = useState(false)

    useEffect(() => {
        props.setLoader(true)
        actions.getSubmissionDetails(releaseID).then(res => {
            props.setLoader(false)
            setFinalInfo(res.body)
        })
    }, [])

    const onSubmit = () => {
        props.setLoader(true)
        actions.submissionButton({ release_id: releaseID }).then(res => {
            props.setLoader(false)
            toastSuccess(res.message)
            history.push('/catalog')
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    const {
        album_artwork = '',
        release_title = '',
        genre = '',
        sub_genre = '',
        lable_name = '',
        primary_artist1 = '',
        number_of_tracks = 0
    } = finalInfo || {}

    return (
        <Grid container className="submission-container" spacing={3}>
            <Grid item xs={12}>
                <Typography variant="h4" sx={{
                    fontWeight: 700,
                    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 2
                }}>
                    Review & Submit Release
                </Typography>
                <Typography variant="body1" sx={{ color: '#5f6368', mb: 3 }}>
                    Please review your release information before submitting.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <SubmissionCard>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Title
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {release_title}
                                </Typography>
                            </Box>

                            <Box mt={2}>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Artist
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {primary_artist1}
                                </Typography>
                            </Box>

                            <Box mt={2}>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Label
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {lable_name}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <Box>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Genre
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {genre}
                                </Typography>
                            </Box>

                            <Box mt={2}>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Subgenre
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {sub_genre}
                                </Typography>
                            </Box>

                            <Box mt={2}>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600 }}>
                                    Number of Tracks
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 600, color: '#202124', mt: 0.5 }}>
                                    {number_of_tracks}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant="caption" sx={{ color: '#5f6368', fontWeight: 600, mb: 1 }}>
                                    Album Artwork
                                </Typography>
                                <Box
                                    sx={{
                                        width: '200px',
                                        height: '200px',
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        border: '2px solid rgba(26, 115, 232, 0.2)',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <img
                                        src={`${API_URL}/${album_artwork}`}
                                        alt="Album artwork"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </SubmissionCard>
            </Grid>

            <Grid item xs={12}>
                <Box
                    sx={{
                        mt: 4,
                        p: 3,
                        background: 'linear-gradient(135deg, rgba(26, 115, 232, 0.05) 0%, rgba(0, 191, 165, 0.05) 100%)',
                        borderRadius: '12px',
                        border: '2px solid rgba(26, 115, 232, 0.2)',
                    }}
                >
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Checkbox
                            checked={checkTerm}
                            onChange={(e) => setCheckTerm(e.target.checked)}
                            sx={{
                                color: '#1a73e8',
                                '&.Mui-checked': {
                                    color: '#00bfa5',
                                },
                            }}
                        />
                        <Typography variant="body1" sx={{ fontWeight: 500, color: '#202124' }}>
                            I understand and agree to the{' '}
                            <a
                                href="https://fronicmedia.com/distribution-agreement"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#1a73e8', fontWeight: 600, textDecoration: 'none' }}
                            >
                                Fronic Media Distribution Terms
                            </a>
                            {' '}&{' '}
                            <a
                                href="http://fronicmedia.com/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#1a73e8', fontWeight: 600, textDecoration: 'none' }}
                            >
                                Privacy Policy
                            </a>
                        </Typography>
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box mt={3} display="flex" justifyContent="center">
                    <StyledButton
                        variant="contained"
                        onClick={onSubmit}
                        disabled={!checkTerm}
                        startIcon={<CheckCircleIcon />}
                    >
                        Submit Release
                    </StyledButton>
                </Box>
            </Grid>
        </Grid>
    )
}

export default Submission
